import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
    const { admin, loading } = useAuth();
    if (loading || admin === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-paper">
                <div className="flex items-center gap-3">
                    <span className="typing-dot" />
                    <span className="typing-dot" />
                    <span className="typing-dot" />
                </div>
            </div>
        );
    }
    if (!admin) return <Navigate to="/login" replace />;
    return children;
}
